<template>
    <div class="notice-list">
        <div class="tools-bar">
            <div class="tools-search" @keyup.enter="handleSearch">
                <el-input maxlength="100" v-model.trim="searchKeyWord" placeholder="名称">
                    <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
                </el-input>
            </div>
            <div class="tools-btn-group">
                <el-button icon="el-icon-circle-plus" type="primary" @click="handleNavNoticeAdd">添加</el-button>
            </div>
        </div>
        <el-table :data="noticeList" style="width: 100%" v-loading="loading" stripe>
            <!-- <el-table-column fixed prop="id" label="ID" width="170"></el-table-column> -->
            <el-table-column prop="noticeTitle" label="公告标题"></el-table-column>
            <el-table-column prop="trueName" label="公告发布人"></el-table-column>
            <el-table-column prop="noticeDate" label="公告发布时间"></el-table-column>
            <el-table-column prop="noticeStatus" label="发布状态">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.noticeStatus === 1" size="small">未发布</el-tag>
                    <el-tag v-if="scope.row.noticeStatus === 2" size="small">发布中</el-tag>
                    <el-tag v-if="scope.row.noticeStatus === 3" size="small">暂停</el-tag>
                    <el-tag v-if="scope.row.noticeStatus === 4" size="small">发布完成</el-tag>
                </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="220">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" icon="el-icon-view" title="预览" circle @click.stop="handleNavNoticeDetail(scope.row)"></el-button>
                    <el-button type="primary" size="mini" icon="el-icon-user-solid" title="阅读情况" circle @click.stop="noticeReadDetail(scope.row)"></el-button>
                    <el-button type="primary" v-if="scope.row.noticeStatus===1" size="mini" icon="el-icon-edit-outline" title="修改" circle @click.stop="handleNavNoticeEdit(scope.row)"></el-button>
                    <el-button type="primary" v-if="scope.row.noticeStatus===1" size="mini" icon="el-icon-caret-right" title="立即发布" circle  @click="handleNoticePublish(scope.row)"></el-button>
                    <el-button type="primary" v-if="scope.row.noticeStatus===1" size="mini" icon="el-icon-time" title="定时发布" circle  @click="handleNoticeCronjobPublish(scope.row)"></el-button>
                    <el-button type="danger"  v-if="showBtn(scope.row)" size="mini" icon="el-icon-delete" title="删除" circle @click="handleNoticeDelete(scope.row)"></el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-row type="flex" justify="end">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :total="totalPageNum"
                :current-page="currentPage"
                :page-size="pageSize"
                @current-change="queryFormData"
                >
            </el-pagination>
        </el-row>

        <el-dialog
            title="编辑公告"
            top="4vh"
            width="95%"
            :visible.sync="isShowNoticeEdit"
            append-to-body
          >
            <NoticeEdit ref="editRef" :key="loadTimer" :notice="noticeInfo" @closeDialog="closeDialog"/>
        </el-dialog>
        <el-dialog
            title="查看公告"
            top="4vh"
            width="95%"
            :fullscreen=true
            :visible.sync="isShowNoticeDetail"
            append-to-body
          >
            <NoticeDetail ref="detailRef" :key="dloadTimer" :notice="noticeDetail" @closeDialog="closeDialog"/>
        </el-dialog>
        <el-dialog
            title="定时发布公告"
            top="4vh"
            width="55%"
            :visible.sync="isShowCronjob"
            append-to-body
          >
            <el-form ref="noticeDateForm" :rules="rules" :model="noticeInfo" size="mini" label-width="120px" class="cronjobNotice-form">
                <el-form-item label="公告标题" prop="noticeTitle" style="width: 340px;">
                    <el-input v-model="noticeInfo.noticeTitle" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item label="执行时间" prop="noticeDate">
                    <el-tooltip  content="设置提醒时间后,到达设置时间时系统会发送到期提醒消息" effect="light" placement="top">
                        <el-date-picker
                            v-model="noticeInfo.noticeDate"
                            type="datetime"
                            placeholder=""
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :editable="true"
                            :clearable="true"
                            :default-value="timeDefaultShow"
                        />
                    </el-tooltip>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleCronjobPublish">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="阅读情况" :visible.sync="dialogTableVisible">
            <div style="display:flex;text-align:center;">
                <div style="border:1px solid #dcdfe6;">
                    <el-divider content-position="left">未读人员</el-divider>
                    <el-table :data="notReadList" height="50vh">
                        <el-table-column property="trueName" label="姓名" width="150"></el-table-column>
                        <el-table-column property="modified" label="阅读时间" width="200"></el-table-column>
                    </el-table>
                </div>
                <div style="margin-left:20px;border:1px solid #dcdfe6">
                    <el-divider content-position="left">已读人员</el-divider>
                    <el-table :data="readList" height="50vh">
                        <el-table-column property="trueName" label="姓名" width="150"></el-table-column>
                        <el-table-column property="modified" label="阅读时间" width="200"></el-table-column>
                    </el-table>
                </div>
            </div>
            
        </el-dialog>
    </div>
</template>

<script>
    import { addScheduleStart, getNoticeList, deleteNotice, publishNotice, publishCronjobNotice, getNoticeReadDetail } from '@/data-model';
    import NoticeEdit from './NoticeEdit';
    import NoticeDetail from './NoticeDetail';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        mixins: [ mixinsNav ],
        components: {
            NoticeEdit,
            NoticeDetail
        },
        data () {
            return {
                isShowNoticeEdit: false,
                isShowNoticeDetail: false,
                isShowCronjob: false,
                timeDefaultShow: '',
                noticeList: [], // 列表数据
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1, // 总页数
                loading: false, // 列表的loading状态
                searchKeyWord: '', // 查询的关键字,
                active: false,
                noticeInfo: {},
                noticeDetail: {},
                loadTimer: '',
                dloadTimer: '',
                currentUser: {},
                rules: {
                    noticeDate: [
                        { required: true, message: '请输入执行时间', trigger: 'blur' }
                    ]
                },
                notReadList: [],
                readList: [],
                dialogTableVisible: false
    
            };
        },
        created () {
            let currentUserStr = window.sessionStorage.getItem('currentUserInfo');
            let currentUserInfo = JSON.parse(currentUserStr);
            this.currentUser = currentUserInfo;
            this._initPage();
        },
        methods: {
            async _initPage () {
                await this._getFormData();
            },
            async _getFormData () {
                this.loading = true;
                let formData = await getNoticeList({
                    currentPage: this.currentPage,
                    pageSize: this.pageSize,
                    noticeTitle: this.searchKeyWord
                });
                this.noticeList = formData.data;
                this.currentPage = formData.currentPage;
                this.pageSize = formData.pageSize;
                this.totalPageNum = formData.totalPageNum;
                this.loading = false;
            },
            showBtn (obj) {
                if (obj.noticeStatus === 1 || obj.modifiedBy === this.currentUser.userId) {
                    return true;
                } else {
                    return false;
                }
            },
            queryFormData (currentPage) {
                this.currentPage = currentPage;
                this._getFormData();
            },
            handleAddScheduleStart (notice) {
                this.$confirm(`您确定要启动定时任务[ ${notice.name} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await addScheduleStart(notice);
                    await this._getFormData();
                }).catch(() => {});
            },
            async handleNoticeDelete (notice) {
                this.$confirm(`您确定要删除公告[ ${notice.noticeTitle} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await deleteNotice(notice.id);
                    await this._getFormData();
                }).catch(() => {});
            },
            async handleNoticePublish (notice) {
                this.$confirm(`您确定要发布公告[ ${notice.noticeTitle} ]吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    await publishNotice(notice.id);
                    await this._getFormData();
                }).catch(() => {});
            },
            handleNoticeCronjobPublish (row) {
                this.noticeInfo = row;
                this.timeDefaultShow = new Date();
                this.isShowCronjob = true;
            },
            async handleCronjobPublish (row) {
                this.$refs['noticeDateForm'].validate(async (valid) => {
                    if (valid) {
                        if (this.noticeInfo) {
                            // let param = {id: this.noticeInfo.id, noticeDate: this.noticeInfo.noticeDate};
                            await publishCronjobNotice(this.noticeInfo);
                            setTimeout(() => {
                                this._getFormData();
                                this.isShowCronjob = false;
                            }, 100);
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleNavNoticeAdd () {
                this.noticeInfo = {};
                this.loadTimer = new Date().getTime();
                this.isShowNoticeEdit = true;
            },
            async handleNavNoticeEdit (row) {
                this.noticeInfo = row;
                this.loadTimer = new Date().getTime();
                this.isShowNoticeEdit = true;
            },
            async handleNavNoticeDetail (row) {
                this.noticeDetail = row;
                this.dloadTimer = new Date().getTime();
                this.isShowNoticeDetail = true;
            },
            handleSearch () {
                this.currentPage = 1;
                this._getFormData();
            },
            closeDialog () {
                this.isShowNoticeEdit = false;
                this.handleSearch();
            },
            async noticeReadDetail (row) {
                let param = {id: row.id};
                let res = await getNoticeReadDetail(param);
                this.notReadList = res.notReadList;
                this.readList = res.readList;
                this.dialogTableVisible = true;
            }
        }
    };
</script>

<style lang="less">
    .notice-list {
        height: 100%;
        width: 100%;
        .cronjobNotice-form {
            width: 700px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/application/Notice/Notice.vue